import type { ComponentProps } from 'react';
// components
import HubertCombobox from 'components/HubertUI/HubertCombobox';
// hooks
import { useGetSupportedJobRolesQuery } from 'rtk/query/apis/misc';
//types
import Loading from 'components/common/Loading';
import IsAxiosError from 'components/common/IsAxiosError';
import { useEffect, useState } from 'react';
import type { TSelectBase } from 'types/general.types';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
}

const RoleIdCombobox = ({ isMulti = false, onValueChange, value, disabled = false, ...props }: Props) => {
  const { data, isLoading, isFetching, isError, error } = useGetSupportedJobRolesQuery();
  const [localItems, setLocalItems] = useState<TSelectBase[]>([]);

  useEffect(() => {
    if (data && data.roles && data.roles.length > 0) {
      setLocalItems(
        data.roles.map((role) => ({
          value: role.value,
          label: `${role.label}${role.active === false ? ' (Inactive)' : ''}`,
          disabled: role.active === false,
        })),
      );
    }
  }, [data, value]);

  if (isLoading || isFetching) {
    return <Loading label="roles" />;
  }

  if (isError) {
    return <IsAxiosError error={error} />;
  }

  if (!data) {
    return null;
  }

  return (
    <div {...props}>
      <HubertCombobox
        itemName="role"
        isMulti={isMulti}
        items={localItems}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default RoleIdCombobox;
